"use strict";Object.defineProperties(exports,{__esModule:{value:!0},[Symbol.toStringTag]:{value:"Module"}});const e=require("@wds/styles");var t=e.createMemoStyles({navSection:{display:"flex",alignItems:"center"}});exports.default=t;
